import React from 'react';
import {useSelector} from 'react-redux';
import {MEMO_KEY_KOST} from 'module/Memo/util/MemoKey'
import {filterOptionsSlctNoValue} from 'module/Slct/util/filterOptionsSlct'
import {cssCFSlct} from 'module/CustomField/style/cssCFInput'
import {selKostSelectDataAll, selKostSelectDataOnlyVisible} from 'module/Kost/selector/KostSelectSelector'
import {SlctLabelOnly} from 'module/Slct/component/SlctLabelOnly'
import {KostSelectComponentProps} from 'module/Kost/type/KostSelectType'
import {selKostLoading} from 'module/Kost/selector/KostSelector'

export const KostSelectComponent = React.memo(function KostSelectComponent(props: KostSelectComponentProps) {
	const {kostkey, onChange, disabled, placeholderHTML, menuWidth, showOnlyVisible, memoSize, memoAutoAdd, autoFocus, align} = props
	const loading = useSelector(selKostLoading)
	let {options, optionsById} = useSelector(showOnlyVisible ? selKostSelectDataOnlyVisible : selKostSelectDataAll)
	return <div className={'CustomFieldKostSelectComponent'} css={cssCFSlct}>
		<SlctLabelOnly
			autoFocus={autoFocus}
			loading={loading}
			value={kostkey}
			options={options}
			byValueCache={optionsById}
			onChange={onChange}
			filterOptions={filterOptionsSlctNoValue}
			disabled={disabled}
			placeholderHTML={placeholderHTML}
			memo={{memoKey: MEMO_KEY_KOST, memoSize: memoSize || 0, memoAutoAdd: memoAutoAdd || false}}
			menuWidth={menuWidth}
			align={align}
		/>
	</div>
})